export const themes = {
    LIGHT: "light",
    DARK: "dark",
};
